import styled from 'styled-components'
import { createGlobalStyle } from 'styled-components'
import { GlobalStyleComponent } from 'styled-components'

export const GlobalStyled = createGlobalStyle`
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    background-color: #414143;
    
}

`